module.exports = __webpack_public_path__ + "img/alt.6fdbe193.svg";